'use strict'

export default (editor, config = {}) => {
  const tm = editor.TraitManager

  // Select trait that maps a class list to the select options.
  // The default select option is set if the input has a class, and class list is modified when select value changes.
  tm.addType('class_select', {
    events: {
      'change': 'onChange' // trigger parent onChange method on input change
    },
    getInputEl: function () {
      if (!this.inputEl) {
        var md = this.model
        var opts = md.get('options') || []
        var input = document.createElement('select')
        // $(input).attr('multiple', 'multiple')
        var targetViewEl = this.target.view.el
        for (let i = 0; i < opts.length; i++) {
          let name = opts[i].name
          let value = opts[i].value
          if (value === '') { value = 'GJS_NO_CLASS' } // 'GJS_NO_CLASS' represents no class--empty string does not trigger value change
          let option = document.createElement('option')
          option.text = name
          option.value = value
          const valueA = value.split(' ')
          // if(target_view_el.classList.contains(value)) {
          // if (_.intersection(targetViewEl.classList, valueA).length === valueA.length) {
          if ($(targetViewEl.classList).not($(targetViewEl.classList).not(valueA)).length === valueA.length) {
            option.setAttribute('selected', 'selected')
          }
          input.append(option)
        }
        this.inputEl = input
        var onInputCrated = this.model.get('onInputCrated')
        if ($.isFunction(onInputCrated)) {
          onInputCrated.call(this)
        }
      }
      return this.inputEl
    },

    onValueChange: function () {
      var classes = this.model.get('options').map(opt => opt.value)
      for (let i = 0; i < classes.length; i++) {
        if (classes[i].length > 0) {
          var classesIA = classes[i].split(' ')
          for (let j = 0; j < classesIA.length; j++) {
            if (classesIA[j].length > 0) {
              this.target.removeClass(classesIA[j])
            }
          }
        }
      }
      const value = this.model.get('value')
      if (value.length > 0 && value !== 'GJS_NO_CLASS') {
        const valueA = value.split(' ')
        for (let i = 0; i < valueA.length; i++) {
          this.target.addClass(valueA[i])
        }
      }
      var onValueChanged = this.model.get('onValueChanged')
      if ($.isFunction(onValueChanged)) {
        onValueChanged.call(this, value)
      }
      this.target.em.trigger('component:toggled')
    }
  })

  tm.addType('attr_select', {
    events: {
      'change': 'onChange' // trigger parent onChange method on input change
    },
    getInputEl: function () {
      let self = this
      if (!self.inputEl) {
        var md = self.model
        var opts = md.get('options') || []
        var input = document.createElement('select')
        let classes = self.model.get('classes')
        if (classes) {
          if (typeof classes === 'string') {
            input.classList.add(classes)
          } else {
            window._.each(classes, (v, k) => {
              input.classList.add(v)
            })
          }
        }
        let defaultOption
        let defaultValue
        let attr = self.model.get('attr')
        if (attr) {
          defaultValue = self.target.getAttributes()[attr]
        }
        // console.log(`defaultValue=${defaultValue}`)
        if (!defaultValue) {
          defaultValue = md.get('defopt') || undefined
        }
        if ($.isFunction(opts)) {
          opts = opts.call(self, opts)
        }
        for (let i = 0; i < opts.length; i++) {
          let name = opts[i].name
          let value = opts[i].value
          if (value === '') { value = 'GJS_NO_CLASS' } // 'GJS_NO_CLASS' represents no class--empty string does not trigger value change
          let option = document.createElement('option')
          if (i === 0) {
            defaultOption = option
          }
          option.text = name
          option.value = value
          if (value === defaultValue) {
            option.setAttribute('selected', 'selected')
            defaultOption = undefined
          }
          input.append(option)
        }
        if (defaultOption) {
          defaultOption.setAttribute('selected', 'selected')
        }
        self.inputEl = input
      }
      return self.inputEl
    },

    onValueChange: function () {
      // console.log('onValueChange', this)
      let self = this
      let attr = self.model.get('attr')
      // console.log('attr', attr)
      if (attr) {
        let a = {}
        a[attr] = self.model.get('value')
        self.target.addAttributes(a)
        var onValueChanged = self.model.get('onValueChanged')
        if ($.isFunction(onValueChanged)) {
          onValueChanged.call(self, a[attr])
        }
        self.target.em.trigger('component:toggled')
      }
    }
  })

  tm.addType('hints_input', {
    events: {
      'change': 'onChange' // trigger parent onChange method on input change
    },
    getInputEl: function () {
      let self = this
      if (!self.inputEl) {
        const md = self.model
        const plh = md.get('placeholder') || md.get('default') || ''
        const type = md.get('type') || 'text'
        const min = md.get('min')
        const max = md.get('max')
        const listdata = md.get('list')
        let list = listdata ? `list="${listdata}"` : ''
        const value = this.getModelValue()

        const input = $(`<input type="${type}" ${list} placeholder="${plh}">`)

        if (value) {
          md.set({ value }, { silent: true })
          input.prop('value', value)
        }
        if (min) {
          input.prop('min', min)
        }
        if (max) {
          input.prop('max', max)
        }
        self.inputEl = input.get(0)
        var onInputCrated = this.model.get('onInputCrated')
        if ($.isFunction(onInputCrated)) {
          onInputCrated.call(this)
        }
      }
      return self.inputEl
    },

    onValueChange: function () {
      let self = this
      let attr = self.model.get('attr')
      const value = self.model.get('value')
      if (attr) {
        let a = {}
        a[attr] = value
        self.target.addAttributes(a)
        self.target.em.trigger('component:toggled')
      }
      var onValueChanged = self.model.get('onValueChanged')
      if ($.isFunction(onValueChanged)) {
        onValueChanged.call(self, value)
      }
    }
  })
}
